module.exports = __webpack_public_path__ + "i18n/pl.821e80f9a0217333083e5bfde191a24d.json";